import React, { useContext, useState } from "react";
import { IconContext } from "react-icons";
import { Link, NavLink } from "react-router-dom";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { BiMenu } from "react-icons/bi";
import { BsFillMoonStarsFill } from "react-icons/bs";
import { BsFillSunFill } from "react-icons/bs";
import logo from "../../../assets/logo/logo-dark.png";
import logoCircle from "../../../assets/logo/logo-circle.png";
import Toggle from "react-toggle";
import "./Sidebar.modules.css";
import { THEME_CONTEXT } from "../../../App";

const Sidebar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const { darkMode, setDarkMode } = useContext(THEME_CONTEXT);

  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu);
  };

  if (darkMode === true) {
    localStorage.setItem("theme", "dark");
  } else {
    localStorage.setItem("theme", "light");
  }

  return (
    <section>
      <div className="sidebar hidden lg:block">
        <div className="w-[220px] fixed left-0 h-screen bg-dark-blue-xxl dark:bg-dark-blue-xxl sidebar-container py-8 flex flex-col justify-between items-center">
          <div>
            <NavLink
              exact="true"
              activeclassname="active"
              className={
                "block text-center py-4 hover:tracking-[.25em] hover:text-[#04BF00] transition-all duration-300"
              }
              to={"/"}
            >
              <img
                src={logo}
                alt="logo"
                className="logo-img w-[120px] ring-0 p-1 ring-[#04BF00]"
              />
            </NavLink>
          </div>

          <div className="divide-y divide-slate-600 border-y-[1px] border-slate-600 w-full text-sm">
            <NavLink
              exact="true"
              activeclassname="active"
              className={
                "block text-center py-4 hover:tracking-[.25em] hover:text-[#04BF00] transition-all duration-300"
              }
              to={"/"}
            >
              Home
            </NavLink>
            <NavLink
              exact="true"
              activeclassname="active"
              className={
                "block text-center py-4 hover:tracking-[.25em] hover:text-[#04BF00] transition-all duration-300 "
              }
              to={"/about"}
            >
              About
            </NavLink>
            <NavLink
              exact="true"
              activeclassname="active"
              className={
                "block text-center py-4 hover:tracking-[.25em] hover:text-[#04BF00] transition-all duration-300"
              }
              to={"/my-projects"}
            >
              My Work
            </NavLink>

            <NavLink
              exact="true"
              activeclassname="active"
              className={
                "block text-center py-4 hover:tracking-[.25em] hover:text-[#04BF00] transition-all duration-300"
              }
              to={"/accomplishments"}
            >
              Accomplishments
            </NavLink>
            <NavLink
              exact="true"
              activeclassname="active"
              className={
                "block text-center py-4 hover:tracking-[.25em] hover:text-[#04BF00] transition-all duration-300"
              }
              to={"/contact"}
            >
              Contact Me
            </NavLink>
          </div>
          <div>
            <Toggle
              checked={darkMode === true}
              icons={{
                checked: <BsFillMoonStarsFill size={"0.7rem"} />,
                unchecked: <BsFillSunFill size={"0.7rem"} />,
              }}
              onChange={() => setDarkMode(!darkMode)}
            />
          </div>
          <div className="grid grid-cols-3 gap-4">
            <IconContext.Provider value={{ className: "hover:text-[#04BF00]" }}>
              <a
                href="https://github.com/ishtiyak98"
                target={"_blank"}
                rel={"noreferrer"}
                className="block hover:scale-125 transition duration-300 "
              >
                <FaGithub className="text-[24px]"></FaGithub>
              </a>

              <a
                href="https://www.linkedin.com/in/rifat-ishtiyak/"
                target={"_blank"}
                rel={"noreferrer"}
                className="block hover:scale-125 transition duration-300"
              >
                <FaLinkedin className="text-[26px]"></FaLinkedin>
              </a>

              <a
                href="https://www.facebook.com/ishtiyak.rifat/"
                target={"_blank"}
                rel={"noreferrer"}
                className="block hover:scale-125 transition duration-300"
              >
                <FaFacebook className="text-[24px]"></FaFacebook>
              </a>
            </IconContext.Provider>
          </div>
          {/* <div>
            <div className="text-center space-y-1 text-slate-400">
              <p className="text-xs">🛠️ Built with React & Tailwind </p>
              <p className="text-xs">🚀 Hosted on Firebase</p>
            </div>
          </div> */}
        </div>
      </div>

      <nav className="z-[100] lg:hidden fixed bg-[#04BF00] top-0 w-full px-2 pt-2 pb-2 ">
        <div className="flex justify-between items-center">
          <div>
            <Link to={"/"} className="flex items-center space-x-2">
              <img src={logoCircle} alt="logo" className="logo-img w-[30px]" />
              <h2 className="title-text tracking-[.05em] text-lg">Ishtiyak</h2>
            </Link>
          </div>
          <div className="flex items-center space-x-5">
            <div className="pt-2">
              <Toggle
                checked={darkMode === true}
                icons={{
                  checked: <BsFillMoonStarsFill size={"0.7rem"} />,
                  unchecked: <BsFillSunFill size={"0.7rem"} />,
                }}
                onChange={() => setDarkMode(!darkMode)}
              />
            </div>
            <div onClick={handleToggleMenu} className="hover:cursor-pointer">
              <IconContext.Provider value={{ className: "text-4xl" }}>
                {toggleMenu ? <BiMenu></BiMenu> : <BiMenu></BiMenu>}
              </IconContext.Provider>
            </div>
          </div>
        </div>
      </nav>
      {/* absolute top-0 pt-14 */}
      <div
        className={`z-[80]  ${
          toggleMenu && "toggle-menu-active"
        }  lg:hidden bg-[#07101f] opacity-100 toggle-menu pt-10 pb-36`}
      >
        <div className="flex flex-col justify-between h-full">
          <div className="divide-y divide-slate-600 border-y-[1px] border-slate-600 w-full">
            <NavLink
              exact="true"
              activeclassname="active"
              className={"block text-center py-4 hover:text-[#04BF00] "}
              to={"/"}
            >
              Home
            </NavLink>
            <NavLink
              exact="true"
              activeclassname="active"
              className={"block text-center py-4 hover:text-[#04BF00] "}
              to={"/about"}
            >
              About
            </NavLink>
            <NavLink
              exact="true"
              activeclassname="active"
              className={"block text-center py-4 hover:text-[#04BF00]"}
              to={"/my-projects"}
            >
              My Work
            </NavLink>

            <NavLink
              exact="true"
              activeclassname="active"
              className={"block text-center py-4 hover:text-[#04BF00]"}
              to={"/accomplishments"}
            >
              Accomplishments
            </NavLink>

            <NavLink
              exact="true"
              activeclassname="active"
              className={"block text-center py-4 hover:text-[#04BF00]"}
              to={"/contact"}
            >
              Contact Me
            </NavLink>
          </div>
          <div className="flex pb-16 items-center justify-center space-x-8 ">
            <IconContext.Provider
              value={{ className: "hover:text-[#04BF00] text-3xl" }}
            >
              <a
                href="https://github.com/ishtiyak98"
                target={"_blank"}
                rel={"noreferrer"}
                className="block hover:scale-125 transition duration-300"
              >
                <FaGithub></FaGithub>
              </a>

              <a
                href="https://www.linkedin.com/in/rifat-ishtiyak/"
                target={"_blank"}
                rel={"noreferrer"}
                className="block hover:scale-125 transition duration-300"
              >
                <FaLinkedin></FaLinkedin>
              </a>

              <a
                href="https://www.facebook.com/ishtiyak.rifat/"
                target={"_blank"}
                rel={"noreferrer"}
                className="block hover:scale-125 transition duration-300"
              >
                <FaFacebook></FaFacebook>
              </a>
            </IconContext.Provider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
